import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TJobLogsCompareVersionsButtonProps } from '@/console/features/jobs/components/job-logs-compare-versions-button/job-logs-compare-versions-button.types';
import { CompareVersionsButton } from '@/console/features/projects/components/compare-versions-button/compare-versions-button';
import { VersionLabel } from '@/shared/components/ui/version-label/version-label';

export const JobLogsCompareVersionsButton = ({
  job,
  onCallback,
}: TJobLogsCompareVersionsButtonProps) => {
  const { t } = useTranslation();
  const projectId = job?.projectIds?.[0];
  const baseVersionId = job?.projectVersionIds?.[0];
  const createdVersionId = job?.metaData?.created_project_version_id;

  const getTooltip = () => {
    return (
      <Stack direction="row" alignItems="center">
        <Typography variant="p8">
          {t('project_viewer:base_version')}:{' '}
        </Typography>
        <VersionLabel
          variant="contrast"
          versionMetadata={{ versionId: baseVersionId }}
        />
        <Typography variant="p8">
          {' , '}
          {t('project_viewer:created_version')}:{' '}
        </Typography>
        <VersionLabel
          variant="contrast"
          versionMetadata={{ versionId: createdVersionId }}
        />
      </Stack>
    );
  };

  if (!projectId || !baseVersionId || !createdVersionId) {
    return null;
  }

  return (
    <CompareVersionsButton
      projectId={projectId}
      baseVersion={baseVersionId}
      targetVersion={createdVersionId}
      onCallback={onCallback}
      tooltip={getTooltip()}
      tooltipProps={{ noMaxWidth: true }}
    />
  );
};
